import React, { useState } from "react";
import Banner1 from "./Banner1";
// Fix the import path for Services
import Services from "../ServiceSection/Services";
// import Card from "./Card";
import OurServices from './OurServices';
import OwerClientSlider from "./OwerClientSlider";
import WhyUs from "./WhyUs";
import GoogleAuth from "./GoogleAuth";
import BrandScrolling from "./BrandScrolling";
import OrganizationScrolling from "./OrganizationScrolling";
import WebsiteOverview from "./WebsiteOverview";
import AboutUs from "./Aboutus";
import ContactUs from "./ContactUs";
import YouTubeLiveStreaming from "./YouTubeLiveStreaming";
import FloatingDownloadButton from "./FloatingDownloadButton";


const Home = () => {
  const [activeCareer] = useState();
  // const [activeTopic, setActiveTopic] = useState("all");

  return (
    <div className="relative w-full overflow-x-hidden">
      {/* Floating Download Button */}
      <FloatingDownloadButton />
      
      <div className="bg-gradient-to-r from-blue-100 via-blue-400 to-[#f2effd] w-full">
        <Banner1 />
        <div className="marquee-container bg-gradient-to-r from-blue-50 via-white to-purple-50 py-4 shadow-lg border-y border-blue-200/30 relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500"></div>
          </div>
          
          <div className="marquee relative z-10">
            <div className="marquee-content text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent drop-shadow-sm">
              🚀 IINSAF - Empowering Voices, Connecting Communities, Driving Digital Innovation Across India's Media Landscape! ✨ &nbsp;
            </div>
            <div className="marquee-content text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent drop-shadow-sm" aria-hidden="true">
              🚀 IINSAF - Empowering Voices, Connecting Communities, Driving Digital Innovation Across India's Media Landscape! ✨ &nbsp;
            </div>
          </div>
          
          {/* Decorative Elements */}
          <div className="absolute top-1 left-3 w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
          <div className="absolute top-1 right-3 w-1.5 h-1.5 bg-purple-500 rounded-full animate-pulse animation-delay-100"></div>
          <div className="absolute bottom-1 left-6 w-1.5 h-1.5 bg-indigo-500 rounded-full animate-pulse animation-delay-200"></div>
          <div className="absolute bottom-1 right-6 w-2 h-2 bg-blue-400 rounded-full animate-pulse animation-delay-300"></div>
        </div>
        
        <div className="py-10 bg-gray-50">
          <Services 
            activeCareer={activeCareer}
          />
        </div>

        {/* Help Videos / Tutorials Section */}
        <section className="py-16 bg-white border-y border-slate-200 relative overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <h2 className="text-3xl font-black text-slate-900 tracking-tight leading-tight sm:text-4xl">
                How It Works & <span className="text-blue-600">Video Tutorials</span>
              </h2>
              <p className="mt-3 text-slate-500 font-bold uppercase tracking-wider text-xs">
                Learn how to leverage the IINSAF platform as an Advertiser or a Reporter
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
              
              {/* Advertiser Guide Card */}
              <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-[2.5rem] p-6 sm:p-8 flex flex-col justify-between shadow-lg hover:shadow-xl transition-all duration-300">
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-blue-50 text-blue-600 rounded-2xl border border-blue-100 flex items-center justify-center">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-black text-slate-800 tracking-tight leading-tight">Advertiser Guide</h3>
                      <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest">How to post campaigns</p>
                    </div>
                  </div>

                  <p className="text-slate-600 text-sm font-medium mb-6 uppercase tracking-wide leading-relaxed">
                    Step-by-step tutorial on how advertisers can create, schedule, select target audience, select locations, and launch campaigns.
                  </p>
                </div>

                {/* Video container centered and aspect ratio tailored for YouTube Short */}
                <div className="w-full max-w-[280px] aspect-[9/16] mx-auto rounded-3xl overflow-hidden border border-slate-200 shadow-xl bg-slate-950">
                  <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/uookHpnxyrY"
                    title="Advertiser Video Guide"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Reporter Guide Card */}
              <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-[2.5rem] p-6 sm:p-8 flex flex-col justify-between shadow-lg hover:shadow-xl transition-all duration-300">
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-red-50 text-red-600 rounded-2xl border border-red-100 flex items-center justify-center">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-black text-slate-800 tracking-tight leading-tight">Reporter Guide</h3>
                      <p className="text-slate-400 text-[10px] uppercase font-bold tracking-widest">How to complete tasks</p>
                    </div>
                  </div>

                  <p className="text-slate-600 text-sm font-medium mb-6 uppercase tracking-wide leading-relaxed">
                    Complete walkthrough showing reporters how to review leads, accept campaigns, perform assignments, upload screenshots, and submit proof.
                  </p>
                </div>

                {/* Video container styled for regular 16:9 layout */}
                <div className="w-full aspect-video rounded-3xl overflow-hidden border border-slate-200 shadow-xl bg-slate-950 my-auto">
                  <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/DxpSmKC3Y1U"
                    title="Reporter Video Guide"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

            </div>
          </div>
        </section>
        

        <YouTubeLiveStreaming />
        <WebsiteOverview />
        <WhyUs />
        {/* <GoogleAuth /> */}
        <BrandScrolling />
        <OrganizationScrolling />
        <OurServices />
        <OwerClientSlider />
        <AboutUs />
        <ContactUs />
      </div>
    </div>
  );
};

export default Home;
